import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleItaobuySicuro() {
  return <ArticleLayout article={articleContents['itaobuy-sicuro']} />;
}